import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'locations',
  templateUrl: './locations.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryLocationsComponent implements OnInit {
  @Input() data;
  @Output() dLocationsEmitter: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {}
  save() {
    this.dLocationsEmitter.emit({ status: 'forward', id: this.data.id });
  }

  back() {
    this.dLocationsEmitter.emit({ status: 'backward' });
  }
}
